import type { SxProps, Theme } from '@mui/material';
import type { ModalProps } from '../hooks/useDialog';
import { mergeSx } from '../utils/styles';

const walletModalPaperStyles: SxProps<Theme> = {
  width: { xs: 1, md: '100%' },
  maxWidth: { xs: '100vw', md: 600 },
  maxHeight: '90%',
  overflow: 'hidden',
  boxSizing: 'border-box',
  m: { xs: 0, md: 2 },
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
  borderBottomLeftRadius: { xs: 0, md: 16 },
  borderBottomRightRadius: { xs: 0, md: 16 },
};

export const getWalletModalProps = (paperSx?: SxProps<Theme>): ModalProps => ({
  anchor: 'bottom',
  useSwipeableDrawer: true,
  maxWidth: 'sm',
  fullWidth: true,
  slotProps: {
    paper: {
      sx: mergeSx(walletModalPaperStyles, paperSx),
    },
  },
});
